import {dataset, lazyCustomElements, listen} from 'nuffjs';

const conf = {
	emailName: 'email',
	acceptConditionsName: 'acceptConditions',
	fieldAttr: 'field',
	submitAttr: 'submit',
	messageAttr: 'message',
	messagesAttr: 'messages',
	newsletterIdAttr: 'newsletterId',
	readyClass: 'ready',
	busyClass: 'busy',
	// invalidClass:
};

class NewsletterForm extends HTMLFormElement {
	static conf = conf;

	static defaultOpts = {
		newsletterId: '',
		messages: {},
	};

	driver = null;
	submitted = false;
	script = null;

	async firstConnectedCallback() {
		this.opts = dataset(this).get(this.constructor.defaultOpts);
		this.message = this.querySelector(dataset.selector(conf.messageAttr));
		this.submitButton = this.querySelector(dataset.selector(conf.submitAttr));
		[this.emailField, this.acceptConditionsField] = await Promise.all([
			lazyCustomElements.querySelector(this, dataset.selector(conf.fieldAttr, conf.emailName)),
			lazyCustomElements.querySelector(
				this,
				dataset.selector(conf.fieldAttr, conf.acceptConditionsName)
			),
		]);
		listen(this, 'submit', this.onSubmit.bind(this));
		listen(this, 'field:change input', this.onChange.bind(this), {
			selector: dataset.selector(conf.fieldAttr),
		});
	}

	onChange(event) {
		this.toggleEnabledSubmit(this.isFilled());
		this.clearMessage();
	}

	onSubmit(event) {
		event.preventDefault();
		if (this.isFilled()) {
			this.doSubmit();
		}
	}

	toggleEnabledSubmit(value) {
		this.submitButton.disabled = !value;
	}

	toggleEnabledFields(value) {
		this.emailField.toggleEnabled(value);
		this.acceptConditionsField.toggleEnabled(value);
	}

	isFilled() {
		return this.emailField.getValue().length && this.acceptConditionsField.getValue() === 1;
	}

	doSubmit() {
		this.clearMessage();
		this.toggleEnabledFields(false);
		this.toggleEnabledSubmit(false);

		const data = {email: this.emailField.getValue()};
		const driver = this.getDriver();
		driver(
			'subscribe:send',
			{recipient: data},
			(response) => {
				console.log('response', response);
				if (response.status === 201) {
					this.message.innerHTML = this.getMessage('success');
					this.emailField.setValue('');
					this.acceptConditionsField.setValue(0);
					this.toggleEnabledFields(true);
				} else if (response.status === 200) {
					if (
						'value' in response &&
						Array.isArray(response.value) &&
						response.value.length &&
						'result' in response.value[0] &&
						'error' in response.value[0].result &&
						'recipients' in response.value[0].result.error &&
						'invalid' in response.value[0].result.error.recipients &&
						Array.isArray(response.value[0].result.error.recipients.invalid) &&
						response.value[0].result.error.recipients.invalid.length
					) {
						this.message.innerHTML = this.getMessage('invalidEmail');
					} else {
						this.message.innerHTML = this.getMessage('alreadyRegistered');
					}
				} else {
					this.message.innerHTML = this.getMessage('genericError');
				}
				this.toggleEnabledFields(true);
			},
			(error) => {
				this.message.innerHTML = this.getMessage('genericError');
				this.toggleEnabledFields(true);
			}
		);
	}

	getDriver() {
		// for testing
		// this.driver = (command, data, successCallback, errorCallback) => {
		// 	setTimeout(() => {
		// 		// successCallback({
		// 		// 	status: 201,
		// 		// });
		// 		// successCallback({
		// 		// 	status: 200,
		// 		// });
		// 		// successCallback({
		// 		// 	status: 200,
		// 		// 	value: [
		// 		// 		{
		// 		// 			result: {
		// 		// 				error: {
		// 		// 					recipients: {
		// 		// 						invalid: ['test'],
		// 		// 					},
		// 		// 				},
		// 		// 			},
		// 		// 		},
		// 		// 	],
		// 		// });
		// 		// successCallback({
		// 		// 	status: 400,
		// 		// });
		// 		errorCallback();
		// 	}, 200);
		// };

		// this library provided by newsletter2go is very stupid: its function cannot be called twice!
		// so we have to unload and reload the script again in order to allow multiple form submits  -__-'

		if (this.script) {
			document.body.removeChild(this.script);
		}
		this.script = document.createElement('script');
		this.script.textContent =
			'!function(e,t,n,c,r,a,i){e.Newsletter2GoTrackingObject=r,e[r]=e[r]||function(){(e[r].q=e[r].q||[]).push(arguments)},e[r].l=1*new Date,a=t.createElement(n),i=t.getElementsByTagName(n)[0],a.async=1,a.src=c,i.parentNode.insertBefore(a,i)}(window,document,"script","https://static.newsletter2go.com/utils.js","n2g");';
		document.body.appendChild(this.script);
		// eslint-disable-next-line piggyback/no-restricted-global-extend
		this.driver = window.n2g;
		this.driver('create', this.opts.newsletterId);
		return this.driver;
	}

	getMessage(name) {
		return '<li>' + this.opts.messages[name] + '</li>';
	}

	clearMessage() {
		this.message.innerHTML = '';
	}
}

export {NewsletterForm};
